import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 400px;
    font-size: 16px;
    line-height: 0.1;
`